export default __webpack_public_path__ + "static/media/dog_v2_2.234a3d35.png";